<div
  data-test="confirmDialog"
  role="alertdialog"
  aria-modal="true"
  [attr.aria-label]="settings.titleText">
  <h1 mat-dialog-title>
    {{ settings.titleText }}
  </h1>

  <p mat-dialog-content class="pt-4 pb-6 text-14">
    {{ settings.bodyText }}
  </p>

  <div
    mat-dialog-actions
    class="dialog__actions pt-2"
    [class.dialog__actions--compact]="!settings.miscText">
    <button *ngIf="settings.miscText" app-button buttonTheme="light" [mat-dialog-close]>
      {{ settings.miscText }}
    </button>

    <div>
      <button
        type="button"
        *ngIf="settings.cancelEnabled"
        class="mr-1"
        app-button
        buttonTheme="light"
        data-test="confirmDialogCancelButton"
        [mat-dialog-close]="false">
        {{ settings.cancelText }}
      </button>

      <button
        type="button"
        *ngIf="settings.confirmEnabled"
        app-button
        buttonType="primary"
        data-test="confirmDialogConfirmButton"
        [mat-dialog-close]="true"
        cdkFocusInitial>
        {{ settings.confirmText }}
      </button>
    </div>
  </div>
</div>
